import i18n from '../../../i18n';

const device = 'Knok Doorbell';

const installationInstructions = {
  intro: {
    currentStep: 'intro',
    headerIcon: 'arrowGrey',
    includeInstallationSteps: true,
    includePairingProcess: true,
    isLastPage: false,
    nextStep: 'beforePairing',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: i18n.t('instructions.congrats', { device }),
    haloDeviceResource: require('@/assets/device-models/MOBELL-1080NB01/Knok_halo.png'),
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_Knok_Camera.png'),
    resourceType: 'image',
    secondaryTx: 'instructions.deviceUpAndRunning',
    continueButtonTx: 'common.startInstallation',
    alternateNextStep: {
      nextStep: 'letsGetStarted',
      nextStepName: 'instructions',
      titleTx: 'common.skipToPairing',
    },
  },
  beforePairing: {
    currentStep: 'beforePairing',
    headerIcon: 'arrowGrey',
    isLastPage: false,
    nextStep: 'steps1-4',
    nextStepName: 'instructions',
    prevStepName: 'installationIntro', // installationIntro doesn't have a prop of :step so omit `prevStep`
    titleTx: 'instructions.MOBELL-1080NB01.beforePairing.title',
    secondaryText: [
      'Installation should be performed by a qualified electrician who is informed about the standards and technical requirements of the doorbell and its proper installation.',
      'To install your Knok Doorbell you need:'
    ],
    steps: [
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/01_ic_wires_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step1.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/02_ic_screws_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step2.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/03_ic_angle_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step3.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step3.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/04_ic_driver_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step4.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step4.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/05_ic_drill_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step5.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step5.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/06_ic_wire_clips_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step6.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step6.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/07_ic_leveler_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step7.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step7.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/08_ic_plate_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step8.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step8.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/09_ic_chime_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step9.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step9.description',
      },
      {
        icon: require('@/assets/device-models/MOBELL-1080NB01/install/10_ic_ladder_black_62px.svg'),
        titleTx: 'instructions.MOBELL-1080NB01.beforePairing.step10.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.beforePairing.step10.description',
      },
    ],
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'beforePairing', // go back to this step when home advisor is closed
      titleTx: 'common.getInstallationHelp',
    },
  },
  'steps1-4': {
    currentStep: 'steps1-4',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'steps5-6',
    nextStepName: 'instructions',
    prevStep: 'beforePairing',
    prevStepName: 'instructions',
    titleTx: 'instructions.MOBELL-1080NB01.steps1-4.title',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_KnokDoorbell_InstallationVideo_Final_Step1-4.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/knok_install_step1-4_poster.png'),
    videoType: 'video/mp4',
    resourceType: 'video',
    videoControls: true,
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.steps1-4.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.steps1-4.step1.description',
        stepNumber: 1
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.steps1-4.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.steps1-4.step2.description',
        stepNumber: 2
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.steps1-4.step3.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.steps1-4.step3.description',
        stepNumber: 3
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.steps1-4.step4.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.steps1-4.step4.description',
        stepNumber: 4
      }
    ],
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'steps1-4', // go back to this step when home advisor is closed
      titleTx: 'common.getInstallationHelp',
    },
  },
  'steps5-6': {
    currentStep: 'steps5-6',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'steps7-8',
    nextStepName: 'instructions',
    prevStep: 'steps1-4',
    prevStepName: 'instructions',
    titleTx: 'instructions.MOBELL-1080NB01.steps5-6.title',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_KnokDoorbell_InstallationVideo_Final_Step5-6.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/knok_install_step5-6_poster.png'),
    videoType: 'video/mp4',
    resourceType: 'video',
    videoControls: true,
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.steps5-6.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.steps5-6.step1.description',
        stepNumber: 5
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.steps5-6.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.steps5-6.step2.description',
        moreInfo: {
          includeIcon: false,
          primaryTx: 'instructions.MOBELL-1080NB01.steps5-6.moreInfo',
          nextStep: 'angleBracket',
          nextStepName: 'instructions'
        },
        stepNumber: 6
      },
      {
        descriptionTx: 'instructions.MOBELL-1080NB01.steps5-6.step3.description',
      },
    ],
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'steps5-6', // go back to this step when home advisor is closed
      titleTx: 'common.getInstallationHelp',
    },
  },
  angleBracket: {
    currentStep: 'angleBracket',
    headerIcon: 'closeBlack',
    isLastPage: false,
    nextStep: 'step9',
    nextStepName: 'instructions',
    prevStep: 'steps5-6',
    prevStepName: 'instructions',
    titleTx: 'instructions.MOBELL-1080NB01.angleBracket.title',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_KnokDoorbell_InstallationVideo_Final_Step_angle_bracket.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/knok_install_angle_bracket_poster.png'),
    videoType: 'video/mp4',
    resourceType: 'video',
    videoControls: true,
    secondaryText: 'If your doorbell is located in a corner, you can use the included horizontal (15°) or vertical (5°) angle bracket to angle the doorbell. This will help point the doorbell in the direction you want to monitor. Instead of installing the mounting bracket directly on the wall you will need to do the following:',
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.angleBracket.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.angleBracket.step1.description',
        stepNumber: 1
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.angleBracket.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.angleBracket.step1.description',
        stepNumber: 2
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.angleBracket.step3.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.angleBracket.step1.description',
        stepNumber: 3
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.angleBracket.step4.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.angleBracket.step1.description',
        stepNumber: 4
      }
    ],
  },
  'steps7-8': {
    currentStep: 'steps7-8',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'step9',
    nextStepName: 'instructions',
    prevStep: 'steps5-6',
    prevStepName: 'instructions',
    titleTx: 'instructions.MOBELL-1080NB01.step7-8.title',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_KnokDoorbell_InstallationVideo_Final_Step7-8.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/knok_install_step7-8_poster.png'),
    videoType: 'video/mp4',
    resourceType: 'video',
    videoControls: true,
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.step7-8.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.step7-8.step1.description',
        stepNumber: 7
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.step7-8.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.step7-8.step2.description',
        stepNumber: 8
      }
    ],
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'steps7-8', // go back to this step when home advisor is closed
      titleTx: 'common.getInstallationHelp',
    },
  },
  step9: {
    // alternateNextStep: N/A,
    currentStep: 'step9',
    includeBanner: false,
    headerIcon: 'arrowGrey',
    isLastPage: false,
    nextStep: 'steps10-11',
    nextStepName: 'instructions',
    prevStep: 'steps7-8',
    prevStepName: 'instructions',
    titleTx: 'instructions.MOBELL-1080NB01.step9.title',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_KnokDoorbell_InstallationVideo_Step9.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/knok_install_step9_poster.png'),
    videoType: 'video/mp4',
    resourceType: 'video',
    videoControls: true,
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.step9.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.step9.step1.description',
        stepNumber: 9
      }
    ],
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'step9', // go back to this step when home advisor is closed
      titleTx: 'common.getInstallationHelp',
    },
  },
  'steps10-11': {
    currentStep: 'steps10-11',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'step12',
    nextStepName: 'instructions',
    prevStep: 'step9',
    prevStepName: 'instructions',
    titleTx: 'instructions.MOBELL-1080NB01.step10-11.title',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_KnokDoorbell_InstallationVideo_Final_Step10-11.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/knok_install_step10-11_poster.png'),
    videoType: 'video/mp4',
    resourceType: 'video',
    videoControls: true,
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.step10-11.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.step10-11.step1.description',
        stepNumber: 10
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.step10-11.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.step10-11.step2.description',
        stepNumber: 11
      }
    ],
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'steps10-11', // go back to this step when home advisor is closed
      titleTx: 'common.getInstallationHelp',
    },
  },
  step12: {
    headerIcon: 'arrowGrey',
    currentStep: 'step12',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStep: 'steps10-11',
    prevStepName: 'instructions',
    titleTx: 'instructions.MOBELL-1080NB01.step12.title',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_KnokDoorbell_InstallationVideo_Step12.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/knok_install_step12_poster.png'),
    videoType: 'video/mp4',
    resourceType: 'video',
    videoControls: true,
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.step12.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.step12.step1.description',
        stepNumber: 12
      }
    ],
    continueButtonTx: 'common.getStarted',
    rightActionItem: {
      tx: 'common.skip',
      nextStep: 'letsGetStarted',
    },
    alternateNextStep: {
      nextStep: 'homeAdvisor',
      nextStepName: 'homeAdvisor',
      lastStep: 'step12', // go back to this step when home advisor is closed
      titleTx: 'common.getInstallationHelp',
    },
  },
  letsGetStarted: {
    headerIcon: 'arrowGrey',
    currentStep: 'letsGetStarted',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    prevStep: 'step12',
    prevStepName: 'instructions',
    resourceType: 'video',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Doorbell_Pairing-Mode_Light.mp4'),
    poster: require('@/assets/device-models/MOBELL-1080NB01/Doorbell_Pairing-Mode_Light_poster.png'),
    videoType: 'video/mp4',
    videoAutoPlay: 'autoplay',
    videoLoop: 'loop',
    videoControls: false,
    primaryTx: 'instructions.MOBELL-1080NB01.letsGetStarted.title',
    secondaryTx: 'instructions.MOBELL-1080NB01.letsGetStarted.subtitle',
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.letsGetStarted.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.letsGetStarted.step1.description',
        stepNumber: 1
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.letsGetStarted.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.letsGetStarted.step2.description',
        stepNumber: 2
      },
    ],
    continueButtonTx: 'common.ready',
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    },
  },
  pairingModeReset: {
    currentStep: 'pairingModeReset',
    headerIcon: 'arrowGrey',
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStep: 'letsGetStarted',
    prevStepName: 'instructions',
    primaryTx: 'instructions.MOBELL-1080NB01.pairingModeReset.title',
    secondaryTx: 'instructions.MOBELL-1080NB01.pairingModeReset.subtitle',
    resource: require('@/assets/device-models/MOBELL-1080NB01/Momentum_Knok_Pairing-Mode.png'),
    resourceType: 'image',
    steps: [
      {
        titleTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step1.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step1.description',
        calloutTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step1.callout',
        stepNumber: 1
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step2.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step2.description',
        stepNumber: 2
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step3.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step3.description',
        stepNumber: 3
      },
      {
        titleTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step4.title',
        descriptionTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step4.description',
        calloutTx: 'instructions.MOBELL-1080NB01.pairingModeReset.step4.callout',
        stepNumber: 4
      }
    ],
  }
};

export default installationInstructions;
